/**
 * The Page preview's document (docs/ui-design.md §4): the run's final HTML,
 * made inert for an `<iframe sandbox="">`. A CSP meta tag comes first, so
 * nothing the script injected can load (no scripts, frames, or remote
 * images), and the page's own `http-equiv` tags (e.g. refresh) are removed.
 */
import { INJECTED_ATTRIBUTE } from "../environments/browser";

export const PREVIEW_CSP = "default-src 'none'; style-src 'unsafe-inline'; img-src data:";

const HEAD_OPEN = /<head\b[^>]*>/i;
const HTTP_EQUIV = /<meta\b[^>]*\bhttp-equiv\b[^>]*>/gi;

export function previewDocument(html: string, options: { highlight: boolean }): string {
  let inject = `<meta http-equiv="Content-Security-Policy" content="${PREVIEW_CSP}">`;
  if (options.highlight) {
    inject += `<style>[${INJECTED_ATTRIBUTE}]{outline:2px dashed #ff9e64 !important;outline-offset:-1px}</style>`;
  }
  const page = html.replace(HTTP_EQUIV, "");
  const head = HEAD_OPEN.exec(page);
  if (!head) return inject + page;
  const at = head.index + head[0].length;
  return page.slice(0, at) + inject + page.slice(at);
}
